export default __webpack_public_path__ + "static/media/bi-top-new.b5ec6640.png";